'use strict';
var parent = require('../../actual/instance/splice');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/instance/splice.js
// module id = 628
// module chunks = 13